<template>
  <div class="transactionDigital">
    <div class="empty-state" v-if="items.length == 0 && !isLoading">
      <svg xmlns="http://www.w3.org/2000/svg" width="259" height="173" viewBox="0 0 259 173">
          <g fill="none" fill-rule="evenodd" transform="translate(-2 -10)">
              <circle cx="130.779" cy="101" r="82" fill="#EE7993" fill-opacity=".1"/>
              <circle cx="131.621" cy="101" r="73.59" fill="#EE7993" fill-opacity=".15"/>
              <g fill-rule="nonzero" transform="rotate(-15 130.133 -185.33)">
                  <rect width="102.225" height="130.242" x=".415" y="9.304" fill="#EE7993" rx="3.62"/>
                  <path fill="#FFADBD" d="M102.64 131.747a3.436 3.436 0 0 1-3.494 3.378H3.909a3.436 3.436 0 0 1-3.494-3.378V12.682a3.436 3.436 0 0 1 3.494-3.378h95.237a3.436 3.436 0 0 1 3.494 3.378v119.065z"/>
                  <rect width="90.354" height="113.951" x="6.756" y="16.407" fill="#FFF" rx="5"/>
                  <path fill="#D7B0B8" d="M80.307 10.404a5.173 5.173 0 0 0-5.173-5.173H27.93a5.173 5.173 0 0 0-5.173 5.173v9.11h57.55v-9.11z"/>
                  <circle cx="51.527" cy="8.02" r="8.02" fill="#D7B0B8"/>
                  <circle cx="51.527" cy="5.569" r="2.461" fill="#FFF"/>
                  <path fill="#EEEBEC" d="M22.757 13.174h57.55v6.341h-57.55z"/>
                  <path fill="#EE7993" d="M80.915 40.342c0 .415-.869.752-1.93.752H20.962c-1.061 0-1.93-.337-1.93-.752s.869-.753 1.93-.753h58.023c1.061-.02 1.93.338 1.93.753zM59.711 43.092c0 .415-.868.753-1.93.753H20.962c-1.061 0-1.93-.338-1.93-.753s.869-.753 1.93-.753h36.82c1.09 0 1.93.338 1.93.753zM49.973 45.881c0 .415-.868.753-1.93.753h-27.08c-1.062 0-1.931-.338-1.931-.753s.869-.752 1.93-.752h27.081c1.062-.01 1.93.337 1.93.752zM80.915 52.965c0 .415-.869.752-1.93.752H20.962c-1.061 0-1.93-.337-1.93-.752s.869-.753 1.93-.753h58.023c1.061-.02 1.93.338 1.93.753zM59.711 55.715c0 .415-.868.753-1.93.753H20.962c-1.061 0-1.93-.338-1.93-.753s.869-.753 1.93-.753h36.82c1.09 0 1.93.338 1.93.753zM49.973 58.504c0 .415-.868.753-1.93.753h-27.08c-1.062 0-1.931-.338-1.931-.753s.869-.752 1.93-.752h27.081c1.062-.01 1.93.337 1.93.752zM80.915 65.588c0 .415-.869.752-1.93.752H20.962c-1.061 0-1.93-.337-1.93-.752s.869-.753 1.93-.753h58.023c1.061-.02 1.93.338 1.93.753zM59.711 68.338c0 .415-.868.753-1.93.753H20.962c-1.061 0-1.93-.338-1.93-.753s.869-.753 1.93-.753h36.82c1.09 0 1.93.338 1.93.753zM49.973 71.127c0 .415-.868.753-1.93.753h-27.08c-1.062 0-1.931-.338-1.931-.753s.869-.752 1.93-.752h27.081c1.062-.01 1.93.337 1.93.752zM80.915 79.358c0 .415-.869.753-1.93.753H20.962c-1.061 0-1.93-.338-1.93-.753s.869-.753 1.93-.753h58.023c1.061-.019 1.93.338 1.93.753zM59.711 82.109c0 .415-.868.752-1.93.752H20.962c-1.061 0-1.93-.337-1.93-.752s.869-.753 1.93-.753h36.82c1.09 0 1.93.338 1.93.753zM49.973 84.898c0 .415-.868.753-1.93.753h-27.08c-1.062 0-1.931-.338-1.931-.753s.869-.753 1.93-.753h27.081c1.062-.01 1.93.338 1.93.753zM80.915 93.129c0 .415-.869.752-1.93.752H20.962c-1.061 0-1.93-.337-1.93-.752s.869-.753 1.93-.753h58.023c1.061-.02 1.93.338 1.93.753zM59.711 95.88c0 .414-.868.752-1.93.752H20.962c-1.061 0-1.93-.338-1.93-.753s.869-.753 1.93-.753h36.82c1.09 0 1.93.338 1.93.753zM49.973 98.668c0 .415-.868.753-1.93.753h-27.08c-1.062 0-1.931-.338-1.931-.753s.869-.753 1.93-.753h27.081c1.062-.01 1.93.338 1.93.753z"/>
              </g>
              <g transform="translate(0 94.692)">
                  <circle cx="222.451" cy="5.467" r="5.467" fill="#FFF" stroke="#A8E4FF" stroke-width="4"/>
                  <circle cx="218.667" cy="64.759" r="2.523" fill="#FFF" stroke="#FFADBD" stroke-width="2"/>
                  <circle cx="208.154" cy="65.179" r="1.262" fill="#FFF" stroke="#A8E4FF" stroke-width="2"/>
                  <circle cx="55.087" cy="65.179" r="1.262" fill="#FFF" stroke="#A8E4FF" stroke-width="2"/>
                  <circle cx="44.574" cy="64.759" r="2.523" fill="#FFF" stroke="#FFADBD" stroke-width="2"/>
                  <circle cx="39.949" cy="6.308" r="5.467" fill="#FFF" stroke="#A8E4FF" stroke-width="4"/>
                  <g fill="#F9D395" transform="translate(241.374 42.051)">
                      <rect width="8.074" height="1.346" x="-.673" y="2.691" rx=".673" transform="rotate(45 3.364 3.364)"/>
                      <rect width="8.074" height="1.346" x="-.673" y="2.691" rx=".673" transform="rotate(-45 3.364 3.364)"/>
                  </g>
                  <g fill="#D8D8D8" transform="rotate(45 90.171 328.14)">
                      <rect width="4.037" height="1" x=".445" y="1.321" rx=".5" transform="rotate(45 2.464 1.742)"/>
                      <rect width="4.037" height="1" x=".564" y="1.321" rx=".5" transform="rotate(-45 2.583 1.742)"/>
                  </g>
                  <g fill="#D8D8D8" transform="rotate(45 -37.244 20.533)">
                      <rect width="4.037" height="1" x=".445" y="1.321" rx=".5" transform="rotate(45 2.464 1.742)"/>
                      <rect width="4.037" height="1" x=".564" y="1.321" rx=".5" transform="rotate(-45 2.583 1.742)"/>
                  </g>
                  <g fill="#F9D395" transform="translate(14.297 42.051)">
                      <rect width="8.074" height="1.346" x="-.673" y="2.691" rx=".673" transform="rotate(45 3.364 3.364)"/>
                      <rect width="8.074" height="1.346" x="-.673" y="2.691" rx=".673" transform="rotate(-45 3.364 3.364)"/>
                  </g>
              </g>
              <path fill="#A6FFB5" fill-rule="nonzero" d="M130.462 91.459l6.975-29.317c.782-2.983 3.756-4.792 6.74-4.01l53.441 13.659c2.984.782 4.793 3.756 4.01 6.74l-6.525 25.416c-.391 1.492-2.924 3.66-4.015 4.368 0 0-.725.575-1.35.284-.625-.292-57.808-15.39-57.808-15.39l-1.468-1.75z"/>
              <path stroke="#537F5A" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M135.705 68.792l1.732-6.65c.782-2.983 3.756-4.792 6.74-4.01l53.441 13.659c2.984.782 4.793 3.756 4.01 6.74l-6.525 25.416c-.391 1.492-1.407 2.692-2.499 3.4M169.096 102.93l-22.991-5.851"/>
              <path stroke="#537F5A" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M174.739 79.08s.099-3.15-6.301-4.764c-4.908-1.224-7.69.827-8.365 3.252-.616 2.3 1.734 4.766 5.96 5.823 5.466 1.331 6.517 3.648 5.96 5.823-.783 2.983-4.641 4.076-8.366 3.252-3.667-.95-6.026-3.723-6.301-4.765M169.328 70.774l-6.242 24.483"/>
              <g transform="translate(123 71)">
                  <path fill="#FFB54C" fill-rule="nonzero" d="M10.345.31C4.69.31 0 1.69 0 3.345v33.103c0 1.655 4.552 3.035 10.345 3.035 5.793 0 10.345-1.38 10.345-3.035V3.345C20.552 1.69 16 .31 10.345.31z"/>
                  <ellipse cx="10.345" cy="3.345" stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" rx="10.345" ry="3.034"/>
                  <path stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.552 8.862c0 1.655-4.552 3.035-10.345 3.035C4.414 11.897 0 10.517 0 8.862M20.552 14.38c0 1.654-4.552 3.034-10.345 3.034C4.414 17.414 0 16.034 0 14.379M20.552 19.897c0 1.655-4.552 3.034-10.345 3.034C4.414 22.931 0 21.551 0 19.897M20.552 25.414c0 1.655-4.552 3.034-10.345 3.034C4.414 28.448 0 27.07 0 25.414M20.552 30.931c0 1.655-4.552 3.035-10.345 3.035C4.414 33.966 0 32.586 0 30.93"/>
                  <path stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.552 3.345v33.103c0 1.655-4.552 3.035-10.345 3.035C4.414 39.483 0 38.103 0 36.448V3.345"/>
              </g>
              <g>
                  <path fill="#FFB54C" fill-rule="nonzero" d="M181.034 91.345c-5.103 0-10.344 1.38-10.344 3.034v33.104c0 1.655 4.551 3.034 10.344 3.034 5.656 0 10.345-1.38 10.345-3.034V94.379c-.138-2.207-5.379-3.172-10.345-3.034z"/>
                  <path stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M191.38 94.38c.137 1.654-4.552 3.034-10.346 3.034-5.793 0-10.344-1.38-10.344-3.035 0-1.655 5.103-3.034 10.344-3.034 4.966-.138 10.207.827 10.345 3.034zM191.38 99.897c0 1.655-4.552 3.034-10.346 3.034-5.793 0-10.344-1.38-10.344-3.034M191.38 105.414c0 1.655-4.552 3.034-10.346 3.034-5.793 0-10.344-1.379-10.344-3.034M191.38 110.931c0 1.655-4.552 3.035-10.346 3.035-5.793 0-10.344-1.38-10.344-3.035M191.38 116.448c0 1.655-4.552 3.035-10.346 3.035-5.793 0-10.344-1.38-10.344-3.035M191.38 121.966c0 1.655-4.552 3.034-10.346 3.034-5.793 0-10.344-1.38-10.344-3.034"/>
                  <path stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M191.38 94.38v33.103c0 1.655-4.552 3.034-10.346 3.034-5.793 0-10.344-1.38-10.344-3.034V94.379"/>
              </g>
              <g transform="translate(145 103)">
                  <path fill="#FFB54C" fill-rule="nonzero" d="M10.862.897C5.207.897.517 2.276.517 3.93V26c0 1.655 4.552 3.034 10.345 3.034 5.793 0 10.345-1.379 10.345-3.034V3.931c0-1.655-4.69-3.034-10.345-3.034z"/>
                  <ellipse cx="10.862" cy="3.931" stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" rx="10.345" ry="3.034"/>
                  <path stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.207 9.448c0 1.655-4.552 3.035-10.345 3.035-5.793 0-10.345-1.38-10.345-3.035M21.207 14.966c0 1.655-4.552 3.034-10.345 3.034C5.07 18 .517 16.62.517 14.966M21.207 20.483c0 1.655-4.552 3.034-10.345 3.034-5.793 0-10.345-1.38-10.345-3.034"/>
                  <path stroke="#C70" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.207 3.931v22.207V26c0 1.655-4.552 3.034-10.345 3.034C5.07 29.034.517 27.655.517 26v.138V3.93"/>
              </g>
          </g>
      </svg>
      <h3 class="regular-font title">Your transaction is empty</h3>
      <p class="small-font description">Time to grow your business!</p>
    </div>
    <adx-loading v-if="isLoading" />
      <transaction-item v-else v-for="(item, index) in items" :key="index" :item="item" />
    <adx-pagination 
      v-if="!isLoading && items.length > 0"
      @change-page="changePage"
      :max-page="maxPage"
      :selected-page="currentPage"
    />
  </div>
</template>

<script>
import TransactionItem from '@/views/Transaction/TransactionItem'
import SideBar from '@/components/SideBar/Desktop'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-transaction-digital',
  components: {
    'transaction-item': TransactionItem,
    "adx-sidebar": SideBar,
    'adx-loading': Loading,
    'adx-pagination': Pagination
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      currentPage: 1,
      maxPage: 1
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadData() {
      (async () => {
        this.isLoading = true
        const params = {
          page: this.currentPage
        }
        const { data } = await api.get(apiV2.transactionHistory, { params, needToken: true })

        this.items = data.results
        this.maxPage = data.max_page
        this.isLoading = false
        
      })();
    },
    changePage (selected) {
      history.pushState(null, null, '?page=' + selected);
      this.currentPage = selected
      this.loadData()
      
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>